module.exports = __webpack_public_path__ + "prod/1.42.2/img/faq1.90963764.png";